import Vue from "vue";

export default {
  namespaced: true,
  state: {},
  actions: {
    getUserMessages() {
      return Vue.axios.get("/helpdesk/messages").then(response => response.data);
    },

    addMessage(module, formData) {
      return Vue.axios
        .post("/helpdesk/message", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => response.data);
    }
  }
};
